import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const blogSliders = document.querySelectorAll('.blog-image-slider .swiper');
blogSliders.forEach(function (elem, i) {
  var section = elem.closest('.blog-image-slider');

  new Swiper(elem, {
    modules: [Navigation],
    slidesPerView: 1.2,
    spaceBetween: 20,
    loop: false,
    speed: 700,
    navigation: {
      nextEl: section.querySelector('.blog-image-slider__btn--next'),
      prevEl: section.querySelector('.blog-image-slider__btn--prev'),
    },
    breakpoints: {
      '768': {
        slidesPerView: 1.6
      }
    }
  })
})
